// extracted by mini-css-extract-plugin
module.exports = {"cont-videos":"cont-videos","contVideos":"cont-videos","action-wrapp":"action-wrapp","actionWrapp":"action-wrapp"};